import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { Typography } from 'antd';

import { QRCodeSVG } from 'qrcode.react';
import Modal from 'v2/components/Shared/Modal';

import mobileCreation from './mobile-creation.png';

const APP_REDIRECT_URL = 'https://app.eduzz.com/?s=eyJzIjoiQmFua0FjY291bnQiLCJwIjp7ImNyZWF0ZUFjY291bnQiOnRydWV9fQ==';
const HELP_APP_BANK_URL =
  'https://ajuda.eduzz.com/hc/pt-br/articles/4408955665051-Como-cadastrar-minha-conta-banc%C3%A1ria-no-App-Eduzz-';

type AppRedirectModalProps = {
  isOpen: boolean;
  setClose: () => void;
};

function AppRedirectModal({ isOpen, setClose }: AppRedirectModalProps) {
  const history = useHistory();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 600;

  const handleGoToAddBankAccount = () => {
    history.push('/producer/profile/add-bank-account');
  };

  const handleRedirectToApp = () => {
    window.open(APP_REDIRECT_URL, '_blank');
    setClose();
  };

  return (
    <Modal
      open={isOpen}
      textTitle='Cadastrar nova conta bancária'
      textReturnButton='Cadastrar pelo site'
      textProceedButton='Cadastrar pelo App'
      setClose={setClose}
      handleProceedClick={handleRedirectToApp}
      handleReturnClick={handleGoToAddBankAccount}
    >
      <div className='flex flex-col gap-4 md:flex-row md:items-start'>
        <div className='flex min-w-0 flex-1 flex-col gap-3'>
          <Typography.Text strong>Chegou a hora de cadastrar sua conta bancária!</Typography.Text>
          <Typography.Paragraph className='mb-0'>
            Facilitamos o caminho para você receber suas vendas.{' '}
            <Typography.Text strong>
              Cadastre sua nova conta pelo App Eduzz e consiga aprovação de forma imediata.
            </Typography.Text>
          </Typography.Paragraph>
          <Typography.Paragraph className='mb-0'>
            {!isMobile
              ? 'Abra sua câmera, escaneie o código ao lado e cadastre sua conta.'
              : 'Clique em "Cadastrar pelo App" e cadastre sua nova conta.'}
          </Typography.Paragraph>
          <Typography.Link href={HELP_APP_BANK_URL} target='_blank' rel='noopener noreferrer'>
            Saiba mais.
          </Typography.Link>
        </div>

        <div className='flex shrink-0 items-center justify-center md:flex-col'>
          {!isMobile ? (
            <QRCodeSVG value={APP_REDIRECT_URL} />
          ) : (
            <img src={mobileCreation} alt='Criar conta bancária mobile' />
          )}
        </div>
      </div>
    </Modal>
  );
}

export { AppRedirectModal };
